import { z } from "zod";
import { supportedLocales } from "@/i18n";

const phonePattern = /^\+[1-9]\d{6,14}$/;

const optionalPhoneSchema = z.preprocess(
  (value) => {
    if (typeof value !== "string") {
      return value;
    }

    const trimmed = value.trim();
    return trimmed === "" ? undefined : trimmed;
  },
  z
    .string()
    .regex(phonePattern, "auth.validation.phone")
    .optional(),
);

export const profileSchema = z.object({
  first_name: z.string().trim().min(1, "auth.validation.required"),
  last_name: z.string().trim().min(1, "auth.validation.required"),
  phone: optionalPhoneSchema,
  language_pref: z.enum(supportedLocales),
});

export const passwordChangeSchema = z
  .object({
    current_password: z.string().min(1, "auth.validation.required"),
    new_password: z.string().min(8, "auth.validation.passwordLength"),
    confirm_password: z.string().min(8, "auth.validation.passwordLength"),
  })
  .refine((data) => data.new_password === data.confirm_password, {
    message: "auth.validation.passwordMatch",
    path: ["confirm_password"],
  });

export type ProfileFormValues = z.input<typeof profileSchema>;
export type ProfileSubmissionValues = z.output<typeof profileSchema>;
export type PasswordChangeFormValues = z.output<typeof passwordChangeSchema>;
